module.exports = __webpack_public_path__ + "img/c7994a8.png";